var link_viewer_default = {
  "fontElementMap": "XtLXD",
  "link": "P0bHx",
  "linkInEditor": "ejyeo",
  "linkInViewer": "WJEyT",
  "toolbarUrlContainer": "kGZOm",
  "toolbarUrl": "bmtEi",
  "toolbarUrlAnchor": "kxVEJ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
